module.exports = __webpack_public_path__ + "static/media/arrow_down_green.ecd5ff5f.svg";